import React from 'react'
import classnames from 'classnames'

export interface ICheckbox {
  checked?: boolean
  name?: string
  size?: string
  children: React.ReactNode
  value?: string
  onChange: any
  info?: boolean
  dataCy?: string
}

const Checkbox = (
  { checked, value, size = 'L', onChange, info, name, children, dataCy }: ICheckbox,
  ref: any,
) => {
  return (
    <div className="inline-flex items-center">
      <label
        className="relative flex cursor-pointer items-center rounded-full text-white"
        htmlFor={name}>
        <input
          id={name}
          name={name}
          type="checkbox"
          value={value}
          ref={ref}
          checked={checked}
          onChange={onChange}
          data-cy={dataCy}
          className={classnames(
            'peer relative h-6 w-6 cursor-pointer appearance-none border-2 border-white text-white checked:border-main-blue checked:!border-opacity-100 hover:border-main-blue hover:border-opacity-40',
            {
              '!h-4 !w-4': size === 'M',
            },
          )}
        />
        <span
          className={classnames(
            'icon-tick pointer-events-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 text-lg text-main-blue opacity-0 peer-checked:!opacity-100 peer-hover:opacity-40',
            {
              'text-sm': size === 'M',
            },
          )}></span>
      </label>
      <label
        className={classnames(
          'cursor-pointer select-none pl-3 font-spaceGrotesk text-lg font-normal text-white',
          {
            'text-sm': size === 'M',
          },
        )}
        htmlFor={name}>
        {children}
      </label>
      {info && (
        <span
          className="
            icon-info
            pl-2
            text-lg
            text-white
            opacity-50"></span>
      )}
    </div>
  )
}

export default Checkbox
